export default __webpack_public_path__ + "static/NJSOMA 2024 1(2) 60 to 65-94f35512a8c302725dddceda23c6ee3c.pdf";